export const NEWS = "news";
